import { render } from "./TheVehicleEvents.vue?vue&type=template&id=29aa9d25"
import script from "./TheVehicleEvents.vue?vue&type=script&lang=js"
export * from "./TheVehicleEvents.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__